import { config } from '../../config';
import { get_route_language } from '../../helpers/routeLanguage';

const trim_trailing_slash = (url) => {
    if (!url) {
        return '';
    }

    if (url.endsWith('/')) {
        return url.slice(0, -1);
    }

    return url;
};

export const build_app_home_url = (lang) => {
    const safeLang = get_route_language(lang || 'en');

    return `${trim_trailing_slash(config.frontendUrl)}/${safeLang}/`;
};

export const build_auth_app_login_url = (lang, redirectUri) => {
    const safeLang = get_route_language(lang || 'en');
    const safeRedirectUri = redirectUri || build_app_home_url(safeLang);
    const searchParams = new URLSearchParams({
        redirectUri: safeRedirectUri
    });

    return `${trim_trailing_slash(config.authFrontendUrl)}/${safeLang}/auth/?${searchParams.toString()}`;
};

export const build_current_app_url = (pathname, search) => {
    return `${window.location.origin}${pathname}${search || ''}`;
};

export const should_bootstrap_keycloak = () => {
    return config.shouldUseKeycloak;
};
